var map = {
	"./promo-how-far-will-fudge-go_00.jpg": 64,
	"./promo-how-far-will-fudge-go_01.jpg": 5083,
	"./promo-how-far-will-fudge-go_02.jpg": 63,
	"./promo-how-far-will-fudge-go_03.jpg": 5084,
	"./promo-how-far-will-fudge-go_04.jpg": 5085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5082;